<template>
  <el-form
    ref="basicForm" size="small" label-position="top"
    :rules="rules"
    :model="paramsForm"
  >
    <el-row :gutter="10">
      <el-col :span="6">
        <!--合同编号-->
        <el-form-item :label="$t('basicData.ContractNumber')" prop="contractNo">
          <el-input
            v-model="paramsForm.contractNo"
            :placeholder="$t('GlobalSetObj.pleaseInput')"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!--客户名称-->
        <el-form-item :label="$t('basicData.CustomerName')" prop="customerId">
          <QueryCustomerCmp :val="paramsForm.customerId" :type="1" @change="val => paramsForm.customerId = val" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!--合同类型-->
        <el-form-item :label="$t('basicData.ContractType')" prop="type">
          <el-select
            v-model="paramsForm.type"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in CONTRACT_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!--付款账期-->
        <el-form-item :label="$t('basicData.PaymentTerms')">
          <!--          <el-select-->
          <!--            v-model="paramsForm.paymentDays"-->
          <!--            :placeholder="$t('GlobalSetObj.pleaseChoose')"-->
          <!--            style="width: 100%"-->
          <!--            clearable-->
          <!--          >-->
          <!--            <el-option-->
          <!--              v-for="item in CONTRACT_PERIOD"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value"-->
          <!--            />-->
          <!--          </el-select>-->
          <el-input
            v-model.number="paramsForm.paymentDays"
            :placeholder="$t('GlobalSetObj.pleaseInput')"
            clearable
            @input="handlePaymentDaysInput"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!--可对账状态-->
        <el-form-item :label="$t('basicData.ReconciliationStatus')" prop="reconciliationStatus">
          <el-select
            v-model="paramsForm.reconciliationStatus"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%"
            clearable
            multiple
          >
            <el-option
              v-for="item in ACCOUNT_STATUS"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!--合同日期-->
        <el-form-item
          :label="$t('basicData.ContractDate')"
          prop="time"
        >
          <!--          :picker-options="datePickerOptions"-->
          <el-date-picker
            v-model="paramsForm.time"
            type="daterange"
            :start-placeholder="$t('GlobalSetObj.startDate')"
            :end-placeholder="$t('GlobalSetObj.endDate')"
            value-format="yyyy-MM-dd"
            :style="{ width: '100%' }"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!--合同状态-->
        <el-form-item :label="$t('basicData.ContractStatus')" prop="status">
          <el-select
            v-model="paramsForm.status"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in CONTRACT_STATUS"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!--备注-->
        <el-form-item :label="$t('basicData.remark')">
          <el-input
            v-model="paramsForm.remark"
            type="textarea"
            :placeholder="$t('GlobalSetObj.pleaseInput')"
            clearable
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { CONTRACT_STATUS, CONTRACT_PERIOD, CONTRACT_TYPE } from '@/views/finance/enums';
import { cloneDeep } from 'lodash-es';
import { apiContractGetReconciliationStatus } from '@/api/finance/contractLedger';

export default {
  name: 'BasicForm',

  components: {
    QueryCustomerCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCmp.vue')
  },

  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      CONTRACT_STATUS,
      CONTRACT_PERIOD,
      CONTRACT_TYPE,
      ACCOUNT_STATUS: [],
      rules: {
        // contractNo: [
        //   {
        //     required: true,
        //     message: this.$t('GlobalSetObj.required'),
        //     trigger: 'blur'
        //   }
        // ],
        customerId: [
          {
            required: true,
            message: this.$t('GlobalSetObj.required'),
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: this.$t('GlobalSetObj.required'),
            trigger: 'blur'
          }
        ],
        time: [
          {
            required: true,
            message: this.$t('GlobalSetObj.required'),
            trigger: 'blur'
          }
        ],
        paymentDays: [
          {
            required: true,
            message: this.$t('GlobalSetObj.required'),
            trigger: 'blur'
          }
        ],
        // reconciliationStatus: [
        //   {
        //     required: true,
        //     message: this.$t('GlobalSetObj.required'),
        //     trigger: 'blur'
        //   }
        // ],
        status: [
          {
            required: true,
            message: this.$t('GlobalSetObj.required'),
            trigger: 'blur'
          }
        ]
      },
      datePickerOptions: {
        disabledDate(time) {
          // 禁用当前日期之后的日期（只能选择今天及之前）
          return time.getTime() > Date.now();
        }
      },
      paramsForm: {
        contractNo: '', // 合同编号
        customerId: '', // 客户名称
        type: '', // 合同类型
        paymentDays: '', // 付款账期
        reconciliationStatus: [], // 可对账状态
        status: '', // 合同状态
        time: [],
        // startDate: '',
        // endDate: '',
        remark: '' // 备注
      }
    };
  },

  watch: {
    formData: {
      handler(newVal, oldVal) {
        console.log('form-初始化', newVal);
        // 判断是否是关键字段变化（排除 businessList 和 fileList）
        const keyFields = ['contractNo', 'customerId', 'type', 'startDate', 'endDate',
          'paymentDays', 'reconciliationStatus', 'status', 'remark'];

        // 首次加载或关键字段变化时才重新初始化
        const isKeyFieldChanged = !oldVal || keyFields.some(key => newVal[key] !== oldVal[key]);

        if (isKeyFieldChanged) {
          this.init();
        }
      },
      deep: true
    }
  },

  created() {
    this.handleReconciliationStatusChange();
  },

  methods: {
    // 初始化
    init() {
      this.paramsForm = {
        ...this.formData,
        time: this.formData.startDate ? [this.formData.startDate, this.formData.endDate] : []
      };

      this.handleReconciliationStatusChange();
    },

    // 校验
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.basicForm.validate(valid => {
          if (valid) {
            const params = cloneDeep(this.paramsForm);
            params.startDate = params.time[0];
            params.endDate = params.time[1];
            resolve(params);
            return true;
          } else {
            reject(false);
          }
        });
      });
    },

    // 重置校验
    resetValidate() {
      this.$refs.basicForm.resetFields();
      this.$refs.basicForm.clearValidate();
    },

    // 对账状态
    handleReconciliationStatusChange() {
      apiContractGetReconciliationStatus().then(res => {
        if (res.code === 200) {
          this.ACCOUNT_STATUS = res.data;
        }
      });
    },

    // 付款账期输入处理 - 只允许正整数
    handlePaymentDaysInput(value) {
      if (!value && value !== 0) {
        return;
      }
      // 移除非数字字符，只保留数字
      const filteredValue = String(value).replace(/[^\d]/g, '');
      // 转换为数字并赋值
      this.paramsForm.paymentDays = filteredValue ? Number(filteredValue) : '';
    }
  }
};
</script>

<style scoped>

</style>
